import { Pipe, PipeTransform } from '@angular/core';
import { ComboCard } from '../../../../../../../../models/menu/product-menu-cards/combo-card';
import { CardType } from '../../menu-cards/card-type.enum';
import { Card } from '../../../../../../../../models/menu/product-menu-cards/card';

@Pipe({
  name: 'isEmbeddedImageCard',
  standalone: false
})
export class IsEmbeddedImageCardPipe implements PipeTransform {
  transform(value: Card): boolean {
    return value instanceof ComboCard ? value?.type === CardType.Embedded : false;
  }
}
